class WsAudioPlayer {
    constructor(config) {
        this.audio = new Audio();
        this.audioList = [];
        this.paused = false;
        this.config = config;
        this.ifNext = false;

        this.audio.addEventListener('ended', () => {
            if (!this.paused) {
                this.playNext();
            }
        });
        this.feed = this.feed.bind(this);
        this.continue = this.continue.bind(this);
        this.pause = this.pause.bind(this);
        this.playNext = this.playNext.bind(this);
        this.reset = this.reset.bind(this);
        this.volume = this.volume.bind(this);
    }

    feed({ data }) {
        this.audioList.push(data);
        if (!this.audio.src) {
            this.playNext();
        }
    }

    continue() {
        if (this.audioList.length && this.ifNext) {
            this.ifNext = false
            let curr = this.audioList.pop();
            this.config.onchange && this.config.onchange(this, curr)
            this.audio.src = `data:audio/${this.config.type};base64,${curr?.text}`;
            this.audio.play();
            this.paused = false;
        }
    }
    stop() {
        this.pause()
        this.audioList = []
        this.audio.src = ''
        this.ifNext = true
    }
    pause() {
        this.audio.pause();
        this.paused = true;
    }
    playNext() {
        this.ifNext = true
        this.audio.pause();
        this.continue();
    }

    reset() {
        this.audioList = [];
        this.audio.src = '';
        this.paused = true;
    }
    volume(vol) {
        this.audio.volume = (vol || 0) / 10;
    }
}

export default WsAudioPlayer;